import { Theme } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useAcknowledgePageStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(),
    },
    header: {
      fontWeight: theme.fontWeight,
    },
    headerGrid: {
      [theme.breakpoints.up('sm')]: {
        marginBottom: theme.spacing(),
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(),
      },
    },
    textSeparator: {
      height: '25px',
    },
  })
);
